import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import BackButton from "../components/BackButton";
import { getCountryCode } from "../Firebase";

function readMobiCountry() {
  try {
    const raw = sessionStorage.getItem("AI_MobiLoginResponse");
    if (!raw) return "";
    const d = JSON.parse(raw);
    return String(d?.Result?.Country || "").toUpperCase();
  } catch {
    return "";
  }
}

const englishContact = (
  <>
    <p className="fs-4">
      The Service AI Avatar in Greece is provided by the Smart Mobile Tech –
      FZCO that it is based in DSO-THUB-G-D-FLEX-G003E, building THUB, Dubai
      Silicon Oasis , Dubai, with VAT 100606110300003 and with DSO-FZCO- 2420 to
      the relevant Chamber of Commerce,
    </p>

    <p className="fs-4">
      The technical support for the provision of the Service in Greece, as it is
      above described, as also the handling of any of your request, in relation
      to the Service, is provided by the company Mobilly S.M.P.C based in
      Tzaferi 16, P.C. 11854, Gazi, Athens, via its technical infrastructure.
    </p>

    <p className="fs-4">
      Consequently, regarding any question, you may contact the Customer Support
      of the company MOBILLY at phone number 2104445975 (standard charge from
      any landline). You may also contact us via email to support@psmsgreece.gr
    </p>

    <p className="fs-4">
      If you wish to unsubscribe from any Service that is provided by the Smart
      Mobile Tech – FZCO and is supported via the MOBILLY technical
      infrastructure in Greece, you should follow one of the below procedures:
    </p>

    <p className="fs-4">
      1. Send the word STOP to 54933/54008 or 54002/54444 by a text message,
      with a standard text message charge, which may vary depending on your
      mobile phone operator.
    </p>

    <p className="fs-4">
      After sending the above message, you will receive a free message from
      54632, which will confirm the termination of your subscription from the
      service(s).
    </p>

    <p className="fs-4">
      2. Call at phone number 2104445975 (standard charge from any landline)
      which corresponds to the MOBILLY Customer Support:
    </p>

    <p className="fs-4">
      - By choosing option (1) and after you follow the recorded instructions,
      you unsubscribe from the service (24hour Customer Support)
    </p>

    <p className="fs-4">
      - By choosing option (2) one of our agents will assist you, in order to
      complete the termination of your subscription (Customer Support: 10 am to
      6pm).
    </p>
  </>
);

const greekContact = (
  <>
    <p className="fs-4">
      Η Υπηρεσία AI Avatar, παρέχεται στην Ελλάδα από την Εταιρεία Smart Mobile
      Tech – FZCO, με έδρα στη DSO-THUB-G-D-FLEX-G003E , building THUB, Dubai
      Silicon Oasis , Dubai, με αριθμό VAT 100606110300003, η οποία είναι
      καταχωρημένη στο οικείο Εμπορικό Επιμελητήριο με αριθμό εγγραφής DSO-FZCO-
      2420
    </p>

    <p className="fs-4">
      Την τεχνική υποστήριξη για την παροχή της Υπηρεσίας στην Ελλάδα με το ως
      άνω τρόπο καθώς και την διαχείριση οποιουδήποτε αιτήματος σε σχέση με την
      παρεχόμενη Υπηρεσία, έχει αναλάβει η εταιρεία Mobilly Μονοπρόσωπη ΙΚΕ, με
      έδρα: Τζαφέρη 16, ΤΚ 11854 Γκάζι-Αθήνα, Ελλάδα, Τηλέφωνο Εξυπηρέτησης
      Πελατών: 2104445975, support@psmsgreece.gr
    </p>

    <p className="fs-4">
      Συνεπώς, για οποιοδήποτε θέμα μπορείτε να επικοινωνήσετε με το Τμήμα
      Εξυπηρέτησης Πελατών της Εταιρείας MOBILLY
    </p>

    <p className="fs-4">
      Σε περίπτωση που επιθυμείτε τη διαγραφή σας από κάποια υπηρεσία που
      παρέχει η Εταιρεία Smart Mobile Tech – FZCO στην Ελλάδα και υποστηρίζεται
      τεχνικά από την εταιρεία MOBILLY, μπορείτε να ακολουθήσετε μία από τις
      παρακάτω διαδικασίες:
    </p>

    <p className="fs-4">
      1. Να αποστείλετε με γραπτό μήνυμα την λέξη STOP στον κωδικό 54933/54008 ή
      54002/54444 με κόστος απλού τυπικού μηνύματος, το οποίο ενδέχεται να
      διαφοροποιείται ανάλογα με τον πάροχο κινητής τηλεφωνίας, που έχετε
      επιλέξει.
    </p>

    <p className="fs-4">
      Μετά την αποστολή του ανωτέρω μηνύματος, θα λάβετε άμεσα δωρεάν μήνυμα από
      το 54632 το οποίο θα επιβεβαιώνει την διαγραφή σας από την υπηρεσία/ες.
    </p>

    <p className="fs-4">
      2. Να καλέσετε στο τηλεφωνικό αριθμό 2104445975 του Τμήματος Εξυπηρέτησης
      Πελατών της Εταιρείας MOBILLY:
    </p>

    <p className="fs-4">
      - Επιλέγοντας (1) και αφού ακολουθήσετε τις ηχογραφημένες οδηγίες
      διαγράφεστε από την Υπηρεσία. (24ωρη Εξυπηρέτηση)
    </p>

    <p className="fs-4">
      - Επιλέγοντας (2) θα εξυπηρετηθείτε από έναν αντιπρόσωπό μας, προκειμένου
      να γίνει η διαγραφή σας (Ώρες Εξυπηρέτησης: 10π.μ. ως 6μ.μ).
    </p>
  </>
);

const ContactGreek = () => {
  const { i18n, t } = useTranslation();
  const [geoCountry, setGeoCountry] = useState("");
  const mobiCountry = useMemo(() => readMobiCountry(), []);

  useEffect(() => {
    getCountryCode()
      .then((c) => setGeoCountry((c || "").trim().toUpperCase()))
      .catch(() => setGeoCountry("OTHER"));
  }, []);

  const lang = (i18n.language || localStorage.getItem("i18nextLng") || "")
    .toString()
    .toLowerCase();
  const isGreekLang = lang.startsWith("el");
  const isPolish = lang.startsWith("pl");

  const isGreece = geoCountry === "GR" || mobiCountry === "GR";

  const renderBody = () => {
    if (isPolish && !isGreece) return null;
    if (isGreece) {
      return isGreekLang ? greekContact : englishContact;
    }
    return englishContact;
  };

  return (
    <div className="terms-of-use container mt-2">
      <BackButton title={t("landing.contact")} />
      {renderBody()}
    </div>
  );
};

export default ContactGreek;
